import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
export const LocationAutocomplete = ({ field, error, locations, onLocationChange, loadingLocations, isEditMode, updateLocationFields, clearLocations, }) => {
    const { control } = useFormContext();
    // Observar los valores de city, zipcode y province
    const [formCity, formZipcode, formProvince] = useWatch({
        control,
        name: ['city', 'zipcode', 'province'],
    });
    const options = locations.map((loc) => ({
        label: loc.text,
        value: loc.value,
    }));
    // Estado para el valor que se muestra en el input
    const [displayValue, setDisplayValue] = useState('');
    // Estado para determinar si ya se seleccionó una opción válida
    const [isSelected, setIsSelected] = useState(false);
    // Al montar el componente, si ya hay valores en city, zipcode y province,
    // construye el label completo y marca la selección como válida.
    useEffect(() => {
        if (formCity && formZipcode && formProvince) {
            const fullLabel = `${formCity}, ${formZipcode}, ${formProvince}`;
            setDisplayValue(fullLabel);
            setIsSelected(true);
            // El formulario sigue almacenando solo el código postal
        }
    }, []); // Se ejecuta solo al montar
    const handleInputChange = (event, newInputValue, reason) => {
        // Solo permitimos modificar si NO se ha seleccionado un valor válido
        if (!isSelected) {
            setDisplayValue(newInputValue);
            field.onChange(newInputValue);
            if (!/^\d{5}$/.test(newInputValue)) {
                updateLocationFields('', '', '');
                if (typeof clearLocations === 'function') {
                    clearLocations();
                }
            }
            if (isEditMode && /^\d{5}$/.test(newInputValue)) {
                onLocationChange(newInputValue);
            }
        }
    };
    // const handleChange = (event: React.SyntheticEvent, newValue: Option | string | null) => {
    //      let value = '';
    //   if (newValue && typeof newValue === 'object') {
    //     value = newValue.label;
    //   } else if (newValue === null) {
    //     value = '';
    //   } else {
    //     value = newValue as string;
    //   }
    //   field.onChange(value);
    //   // Si se selecciona una opción válida, se extraen los datos y se actualizan los campos
    //   const validOption = options.find((opt) => opt.label === value);
    //   if (validOption) {
    //     const parts = validOption.label.split(',');
    //     if (parts.length >= 3) {
    //       const city = parts[0].trim();
    //       const zipCode = parts[1].trim();
    //       const province = parts[2].trim();
    //       updateLocationFields(city, zipCode, province);
    //     }
    //   }
    // };
    const handleChange = (event, newValue) => {
        let zipCode = "";
        let fullLabel = "";
        if (newValue && typeof newValue === "object") {
            // Se seleccionó una opción válida
            zipCode = newValue.value; // Solo 5 dígitos para el formulario
            fullLabel = newValue.label;
            setIsSelected(true);
        }
        else if (newValue === null) {
            zipCode = "";
            fullLabel = "";
            setIsSelected(false);
        }
        else {
            zipCode = newValue;
            fullLabel = newValue;
            setIsSelected(false);
        }
        field.onChange(zipCode);
        setDisplayValue(fullLabel);
        // Si se seleccionó una opción válida, actualizamos también los otros campos
        const validOption = options.find((opt) => opt.value === zipCode);
        if (validOption) {
            const parts = validOption.label.split(",").map(part => part.trim());
            // Extraer el código postal (siempre es un número de 5 dígitos)
            const zipIndex = parts.findIndex(part => /^\d{5}$/.test(part));
            if (zipIndex === -1) {
                console.error("No se encontró un código postal válido en la etiqueta.");
                return;
            }
            // Extraer la ciudad (todo antes del código postal, unido por comas)
            const cityParts = parts.slice(0, zipIndex);
            const city = cityParts.join(", ");
            // Extraer la provincia (todo después del código postal, unido por comas)
            const provinceParts = parts.slice(zipIndex + 1);
            const province = provinceParts.join(", ");
            updateLocationFields(city, parts[zipIndex], province);
        }
    };
    const handleBlur = (event) => {
        field.onBlur();
    };
    return (_jsx(Autocomplete, { freeSolo: true, disabled: !isEditMode, disableClearable: false, options: options, getOptionLabel: (option) => (typeof option === 'string' ? option : option.label), value: displayValue, inputValue: displayValue, onInputChange: handleInputChange, onChange: handleChange, renderInput: (params) => {
            var _a;
            // El input es de solo lectura solo cuando se ha seleccionado un valor válido
            const readOnly = isSelected;
            return (_jsx(TextField, Object.assign({}, params, { fullWidth: true, size: "small", error: !!error, helperText: error ? error.message : '', onBlur: handleBlur, slotProps: {
                    // Estas props se aplican al contenedor del input
                    input: Object.assign(Object.assign({}, params.InputProps), { readOnly: readOnly, endAdornment: (_jsxs(_Fragment, { children: [loadingLocations && _jsx(CircularProgress, { color: "inherit", size: 20 }), (_a = params.InputProps) === null || _a === void 0 ? void 0 : _a.endAdornment] })) }),
                    // Estas props se aplican directamente al <input>
                    htmlInput: Object.assign(Object.assign({}, params.inputProps), { maxLength: 5, inputMode: 'numeric', pattern: '[0-9]*', onKeyDown: (e) => {
                            // Si hay un valor seleccionado, se bloquea la edición por teclado
                            if (readOnly) {
                                e.preventDefault();
                                return;
                            }
                            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
                            if (allowedKeys.includes(e.key))
                                return;
                            if (!/^[0-9]$/.test(e.key)) {
                                e.preventDefault();
                            }
                        } }),
                } })));
        } }));
};
